import React, { Component } from 'react'
import { bookingReference } from 'helpers/bookingReference';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { 
  Button,FormGroup,Checkbox, Radio,
  Intent, Spinner, RadioGroup
} from "@blueprintjs/core";
import Toast from 'helpers/toaster';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import DateTimeInput from 'components/DateTimeInput';
import moment from 'moment';
import GeoComplete from '../../helpers/GeoComplete';
import { Select } from "@blueprintjs/select";
import { currencySymbol, currencyFormattedAmount } from 'helpers/currency';
import QuestionRadio from 'components/Booking/QuestionRadio';
import QuestionSelect from 'components/Booking/QuestionSelect';
import QuestionTextbox from 'components/Booking/QuestionTextbox';
import { hasGroupedQuestions,
  BookingPageHeader, BookingSection, BookingTicket, BookingAttachments,
  ServiceTypeSelectWrap, joinAddress
} from 'components/Booking/BookingLayout';
import { normalizeHex } from 'helpers/serviceTypeColor';
import { flatOptionLabel, flatOptionQuantity } from 'helpers/bookingPricing';

var startCount = 0;
var startCountRange = 0
var selectedAnswer = '';
var princingRangeCombineArray = [];

const items=[ 
  { label: 'Cash', value: 'Cash' }, 
  { label: 'Interac', value: 'Interac' },
  { label: 'Cheque', value: 'Cheque' },
  { label: 'Debit/Credit', value: 'dr/cr' }
];



@inject('store','viewStore','bookingStore','preferenceStore','serviceTypeStore','pricingParameterStore','frequencyStore','questionGroupStore','serviceAgreementStore','jobStore','serviceTypeCategoryStore') @observer
class NewBooking extends Component {
  @observable pricingParameterArray = [];

  constructor(props) {
    super(props);
    this.state = {
      isServiceTypeChecked: 0,
      isPaymentSelect:0,
      isFrequencySelected: null
    };
  }

  @observable startCountRange = 0;
  @observable extra_service_total = 0;
  @observable pricing_parameter_total = 0;
  @observable pricing_range_total = 0;
  @observable isServiceExtraChecked = 0;
  @observable grand_total = 0.0;
  @observable showAsIconOrText = false;

  componentDidMount() {
    let {
      serviceTypeStore,
      questionGroupStore,
      bookingStore,
      serviceTypeCategoryStore,
      bookingStore:{
        booking:{
          object
        }
      }
    } = this.props;
    serviceTypeCategoryStore.loadServiceTypeCategories();
    serviceTypeStore.loadServiceTypesBooking();
    questionGroupStore.loadQuestionGroups();
  }

  onAddressSelect(suggestion) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(suggestion) {
      object.attributes.address = suggestion.label;
      suggestion.gmaps && suggestion.gmaps.address_components && suggestion.gmaps.address_components.length > 0 && suggestion.gmaps.address_components.map((address_component) => {
        if(_.includes(address_component.types, "locality")) {
          object.attributes.city = address_component.long_name;
        }

        if(_.includes(address_component.types, "administrative_area_level_1")) {
          object.attributes.state = address_component.long_name;
        }
        
        if(_.includes(address_component.types, "postal_code")) {
          object.attributes.zip = address_component.long_name;
        }
      })
    } else {
      object.attributes.address = '';
      object.attributes.zip = "";
      object.attributes.state = "";
      object.attributes.city = "";
    }
  }

  onAddressClear(value) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(!value) {
      object.attributes.address = '';
    }
  }

  onExtraServiceSelect(event,selectedOptions,key) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
   var removeIndex = object.attributes.extra_service_types.map(function(item) { return item.name; }).indexOf(selectedOptions.name);
    if(event.target.checked === true){
      object.attributes.extra_service_types.push({service_type_extra_id:selectedOptions.id,name:selectedOptions.name,price:parseFloat(selectedOptions.price_cents/100)});
    }else{
      object.attributes.extra_service_types.splice(removeIndex, 1);
    }
    this.isServiceExtraChecked = key;
    this.calculateGrandtotal()
  }

  onFrequencySelect(event,selectedOptions,key) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    object.attributes.frequency_id = selectedOptions.id;
    this.setState({
      isFrequencySelected: key,
    });
  }

  onPricingRangeSelectImage(event,selectedOptions,key) { 
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;

    if(event.target.checked){
      let index = object.attributes.pricing_parameter_ranges.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.pricing_parameter_id);
      if(index > -1){
        object.attributes.pricing_parameter_ranges[index].pricing_parameter_id = selectedOptions.pricing_parameter_id;
        object.attributes.pricing_parameter_ranges[index].name = selectedOptions.label;
        object.attributes.pricing_parameter_ranges[index].price = selectedOptions.price;
        object.attributes.pricing_parameter_ranges[index].total_amount =  selectedOptions.price;
      }else{
        object.attributes.pricing_parameter_ranges.push({pricing_parameter_id:selectedOptions.pricing_parameter_id,name:selectedOptions.label,price:selectedOptions.price,total_amount:selectedOptions.price});
      }
      this.calculateGrandtotal()
    }
  }

  onPricingRangeSelect(event,selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    // if(event.target.value != ''){
    //   object.attributes.pricing_parameter_ranges = [];
    //   object.attributes.pricing_parameter_ranges.push({pricing_parameter_id:selectedOptions.id,name:event.target.options[event.target.selectedIndex].text,price:parseFloat(event.target.value)});
    // } else {
    //   object.attributes.pricing_parameter_ranges = [];
    // }
    // this.calculateGrandtotal()

    if(event.target.value != ''){
      let index = object.attributes.pricing_parameter_ranges.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if(index > -1){
        object.attributes.pricing_parameter_ranges[index].pricing_parameter_id = selectedOptions.id;
        object.attributes.pricing_parameter_ranges[index].name = event.target.options[event.target.selectedIndex].text;
        object.attributes.pricing_parameter_ranges[index].price = parseFloat(event.target.value);
        object.attributes.pricing_parameter_ranges[index].total_amount = parseFloat(event.target.selectedIndex) * parseFloat(event.target.value);

      }else{
        object.attributes.pricing_parameter_ranges.push({pricing_parameter_id:selectedOptions.id,name:event.target.options[event.target.selectedIndex].text,price:parseFloat(event.target.value),total_amount:parseFloat(event.target.value)});
      
      }
      this.calculateGrandtotal()
    }
  }

  onPricingSelect(event,selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;

    if(event.target.value != ''){
      object.attributes.pricing_parameters = [];
      object.attributes.pricing_parameters.push({pricing_parameter_id:selectedOptions.id,name:event.target.options[event.target.selectedIndex].text,price:parseFloat((selectedOptions.price_cents/100))});
      // NOTE: here price came from backend in cents
      // Quantity is the number in the option label ("Tires x 4" is 4), as the server prices it.
      const quantity = flatOptionQuantity(flatOptionLabel(event));
      object.attributes.pricing_parameters[0].quantity = quantity;
      object.attributes.pricing_parameters[0].total_amount = quantity * parseFloat((selectedOptions.price_cents/100));
    } else {
      object.attributes.pricing_parameters = [];
    }
    this.calculateGrandtotal()
  }

  // The saved choice for a flat pricing parameter (e.g. "Tires x 3"), so its
  // select shows it. Saved bookings keep choices in booking_pricing_parameters,
  // new ones in pricing_parameters; both store the option text as `name`.
  selectedPricingLabel(pricing) {
    const { object } = this.props.bookingStore.booking;
    const attributes = (object && object.attributes) || {};
    // Option text has its whitespace collapsed by the browser (a name like
    // "Tires x " gives "Tires x  4" in code but "Tires x 4" as the option and
    // as the saved name), so compare and return the collapsed form.
    const tidy = (text) => String(text || '').replace(/\s+/g, ' ').trim();
    const saved = [...(attributes.booking_pricing_parameters || []), ...(attributes.pricing_parameters || [])]
      .map((item) => item && tidy(item.name));
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      const label = tidy(`${pricing.name} ${i}`);
      if (saved.includes(label)) return label;
    }
    return '';
  }

  pricingList = (pricing) => {
    let pricingToReturn = [];
    this.pricingParameterArray = [];
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
    }
    return pricingToReturn;
  };

  pricingRangeList = (pricing) => {
    let {
      props: {
        pricingParameterStore,
        pricingParameterStore: {
          pricingParameterDetailUpdate: { 
            object
           }
        }
      }
    } = this;
    let { 
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    let pricingRangeToReturn = [];

    if(pricing.id){
      let index = pricing.pricing_parameter_ranges.map(function(item) { return item.pricing_parameter_id; }).indexOf(pricing.id);
      if(index > -1){
        pricing.pricing_parameter_ranges.map((range) => {
          pricingRangeToReturn.push(<option innerText={range.label} value={range.price}>{range.label}</option>);
        });
      }
    }
    return pricingRangeToReturn;
  };

  handleStartDateChange(date) {
    let { object } = this.props.bookingStore.booking;
    if(date) {
      object.attributes.start_date = moment(date);
    }
  }

  onPaymentSelect = (event,payment,key) => {
    let { object } = this.props.bookingStore.booking;
    this.setState({
      isPaymentSelect: key,
    });
    object.attributes.payment_method = payment.value;
  }

  onContactWayChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.contact_way = event.target.value;
  }

  onTimePeriodChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.start_project_expected_period = event.target.value;
  }

  onServiceTypeSelect = (event,service,key) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore} = this.props;
    let { 
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    if(service.attributes.id !== "") {
      this.setState({
        isServiceTypeChecked: service.attributes.id
      });
      princingRangeCombineArray = [];
      object.attributes.extra_service_types = [];
      object.attributes.pricing_parameters = [];
      object.attributes.pricing_parameter_ranges = [];
      object.attributes.service_type_id = service.attributes.id;
      serviceTypeStore.loadServiceTypeDetail({uuid:service.attributes.id})
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
            // pricingParameterStore.loadPricingParameterDetail({uuid:pricing_attr.id})
            // .then(response => {
            //   princingRangeCombineArray.push(response.data.data)
            // })
          });
          this.calculateGrandtotal()
        })
    }else{
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  onServiceTypeCategoryChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    this.props.viewStore.serviceTypeSearch.where.service_type_category_id = event.target.value;
    this.props.serviceTypeStore.loadServiceTypes() 
    object.attributes.service_type_category_id = event.target.value;
  }

  onServiceTypeChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore} = this.props;
    let { 
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    if(event.target.value !== "") {
      this.setState({
        isServiceTypeChecked: event.target.value
      });
      princingRangeCombineArray = [];
      object.attributes.extra_service_types = [];
      object.attributes.pricing_parameters = [];
      object.attributes.pricing_parameter_ranges = [];
      object.attributes.service_type_id = event.target.value;
      serviceTypeStore.loadServiceTypeDetail({uuid:event.target.value})
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
          });
          this.calculateGrandtotal()
        })
    } else {
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  calculateGrandtotal() {
    let { 
      bookingStore: {
        booking: {
          object
        }
      },
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;

    this.grand_total = 0.0;

    // Adding Service type price in grand total
    if(serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      this.grand_total += serviceTypeDetail.object.attributes.rate;
    }

    // Adding pricing parameters flat to grand total
    if(object && object.attributes.pricing_parameters && object.attributes.pricing_parameters.length > 0) {
      this.grand_total += _.sumBy(object.attributes.pricing_parameters, 'total_amount')
    }

    // Adding pricing parameters range to grand total
    if(object && object.attributes.pricing_parameter_ranges && object.attributes.pricing_parameter_ranges.length > 0) {
      this.grand_total += _.sumBy(object.attributes.pricing_parameter_ranges, 'price')
    }

    // Adding extra service types to grand total
    if(object && object.attributes.extra_service_types && object.attributes.extra_service_types.length > 0) {
      this.grand_total += _.sumBy(object.attributes.extra_service_types, 'price')
    }
  }

  createBooking(status) {
    let {
      props: {
        store,
        frequencyStore:{
          frequencies
        },
        serviceTypeStore: {
          serviceType:{
            objects,
          }
        },
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
   
    if(object.attributes.service_type_category_id === "" || object.attributes.service_type_category_id === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please select service type category!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.first_name === "" || object.attributes.first_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.last_name === "" || object.attributes.last_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.email === "" || object.attributes.email === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.phone === "" || object.attributes.phone === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.address === "" || object.attributes.address === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.city === "" || object.attributes.city === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.state === "" || object.attributes.state === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.zip === "" || object.attributes.zip === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
      return;
    }
    
    if(object.attributes.service_type_id === "" || object.attributes.service_type_id === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please select service type!', intent: Intent.DANGER })
      return;
    }
    
   

    if(object.attributes.payment_method === "" || object.attributes.payment_method === null) {
      object.attributes.payment_method = 'Cash';
    }

    object.attributes.total = this.grand_total;
    object.attributes.booking_pricing_parameters_attributes = object.attributes.pricing_parameters.concat(object.attributes.pricing_parameter_ranges);
    object.attributes.booking_service_type_extras_attributes = object.attributes.extra_service_types;
    object.attributes.status = status;
    object.attributes.booking_questions_attributes = object.attributes.booking_questions;

    this.props.bookingStore
      .createBooking()
      .then(response => {
        const created = response.data.data;
        Toast.show({
          icon: "tick",
          message: `Booking ${bookingReference(created.id)} ${created.attributes.status === 'confirmed' ? 'confirmed' : 'saved as draft'}`,
          intent: Intent.SUCCESS,
          timeout: 8000,
          action: { text: 'Open', onClick: () => this.props.viewStore.bookingShow({ uuid: created.id }) },
        });
        
        if(response.data.data.attributes.status === 'confirmed'){
          if(response.data.data.attributes.frequency.title === 'One Time'){
            let { object } = this.props.jobStore.persistJob;
            object.reason_for_call = response.data.data.attributes.service_type.name;
            object.start_date = moment(response.data.data.attributes.start_date);
            object.end_date = moment(response.data.data.attributes.start_date);
            object.service_type_id = response.data.data.attributes.service_type_id;
            object.selectedServiceType = [{value: response.data.data.attributes.service_type_id,selected: true,label: response.data.data.attributes.service_type.name}];
            store.isOpen = true;
            object.booking_id = response.data.data.attributes.id;
          }else{
            let {object } = this.props.serviceAgreementStore.persistServiceAgreement;
            let frequencyType = response.data.data.attributes.frequency.title;
            let frequencyTypeString = response.data.data.attributes.frequency.title.toUpperCase();
            let startDate = moment(response.data.data.attributes.start_date).format('YYYYMMDDTHHmmssz');
            object.reason_for_call = response.data.data.attributes.service_type.name;
            object.selectedServiceType = [{value: response.data.data.attributes.service_type_id,selected: true,label: response.data.data.attributes.service_type.name}];
            object.service_type_id = response.data.data.attributes.service_type_id;
            var string = '';
            if(frequencyType === 'Weekly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${frequencyTypeString};INTERVAL=1;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Bi-weekly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${'WEEKLY'};INTERVAL=2;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Monthly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${frequencyTypeString};INTERVAL=1;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Quarterly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${'MONTHLY'};INTERVAL=3;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Semi-annually'){
              string = `DTSTART:${startDate} RRULE:FREQ=${frequencyTypeString};INTERVAL=6;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Annually'){
              string = `DTSTART:${startDate} RRULE:FREQ=${'YEARLY'};INTERVAL=1;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Yearly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${'YEARLY'};INTERVAL=1;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Every other year'){
              string = `DTSTART:${startDate} RRULE:FREQ=${frequencyTypeString};INTERVAL=1;BYMONTHDAY=1`;
            }
            object.booking_id = response.data.data.attributes.id;
            object.rrule = string;
            this.props.jobStore.isServiceAgreement = true;
            this.props.store.isOpen = true;
          }
        }


      })
      .catch(error => {
        Toast.show({
          icon: "warning-sign",
          message: "Unable to create Booking!",
          intent: Intent.DANGER
        });
      });

  }

  onQuestionChange = (event,question) => {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    let index = object.attributes.booking_questions_attributes.map(function(item) { return item.question_id; }).indexOf(question.id);
    if(index > -1){
      object.attributes.booking_questions_attributes[index].answer = event.target.value;
    }else{
      object.attributes.booking_questions_attributes.push({answer:event.target.value,question_id:question.id});
    }
  }

  onChangeFile(event) {
    let {
      bookingStore:{
        booking:{
          object: { attributes }
        }
      }
    } = this.props;
    var FileSize = event.target.files[0].size / 1024 / 1024; // in MB
    if (FileSize > 10) {
      Toast.show({ icon: 'warning-sign', message: 'File size exceeds 10 MB!', intent: Intent.DANGER })
      return
    }
    this.props.bookingStore.uploadBookingAttachment(event.target.files[0])
      .then(this.onSuccessfullUploadAttachment.bind(this))
      .catch(this.onFailUploadAttachment.bind(this))
  }

  onSuccessfullUploadAttachment(response) {
    let {
      bookingStore:{
        booking:{
          object
        }
      }
    } = this.props;
    object.attributes.booking_attachment_ids.push(response.data.data.attributes.id);
    object.attributes.booking_attachments.push(response.data.data.attributes);
  }

  onFailUploadAttachment(error) {
    this.props.bookingStore.showUploadAttachmentLoader = false;
    if(error.response && error.response.data && error.response.data.errors) {
      Toast.show({ icon: 'warning-sign', message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ icon: 'warning-sign', message: 'Something went wrong, failed to upload file!', intent: Intent.DANGER })
    }
  }

  removeAttachment(attachment) {
    let {
      bookingStore:{
        booking:{
          object
        }
      }
    } = this.props;
    var removeIndex = object.attributes.booking_attachments.map(function(item) { return item.id; }).indexOf(attachment.id);
    if(removeIndex > -1){
      object.attributes.booking_attachments.splice(removeIndex, 1);
      object.attributes.booking_attachment_ids.splice(removeIndex, 1);
    }
  }


  renderPricingParameters(pricing_parameters, attributes) {
    if(!(pricing_parameters && pricing_parameters.length > 0)) {
      return null;
    }
    return (
      <div className="bk-pricing">
        <div className="bk-grid bk-grid--2">
        {
          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing,pricingKey) => {
            if(pricing.pricing_type === 'flat'){
              return (
                <div className="bk-field">
                  <FormGroup label={"Pricing"} labelFor="text-input">
                    <select
                      value={this.selectedPricingLabel(pricing)}
                      className='form-control'
                      placeholder={`Select ${pricing.name}`}
                      onChange={(event) => {this.onPricingSelect(event,pricing)} }
                    >
                      <option value="">Select one</option>
                    { this.pricingList(pricing)}
                    </select>
                  </FormGroup>
                </div>
              )
            }
          })
        }
        </div>
        <div className="bk-grid bk-grid--2">
        {
          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing) => {
            if(pricing.pricing_type === 'range'){
              var index = pricing.pricing_parameter_ranges.length === _.filter(pricing.pricing_parameter_ranges, function(obj) { return obj.image_url; }).length
              return (
                <div className={index === true ? "bk-field bk-field--full" : "bk-field"}>
                  <FormGroup
                    label={pricing.name}
                    labelFor="text-input"
                    labelInfo={"*"}
                  >
                    {
                      index === true ?
                      <div className="bk-image-options">
                        {pricing.pricing_parameter_ranges.map((pricing_range,key) => {
                          let indexChecked = attributes && attributes.pricing_parameter_ranges.map(function(item) { return item.name; }).indexOf(pricing_range.label);
                          var checked_id ='';
                          if(indexChecked > -1){
                            checked_id = pricing_range.id;
                          }
                          return (
                            <div className={`bk-image-option ${checked_id === pricing_range.id ? 'bk-image-option--active' : ''}`} key={pricing_range.id || key}>
                              <div className="bk-image-option__media">
                                <img src={pricing_range.image_url} alt="" />
                                <Radio type="radio" name="checkboxgroup"
                                  className="bk-image-option__radio"
                                  checked={checked_id === pricing_range.id ? true: false}
                                  onChange={(event) => {this.onPricingRangeSelectImage(event,pricing_range,key)} }
                                />
                              </div>
                              <span className="bk-image-option__label">{pricing_range.label}</span>
                            </div>
                          )
                        })}
                      </div>:
                      <select
                        className='form-control'
                        placeholder={`Select ${pricing.name}`}
                        onChange={(event) => { this.onPricingRangeSelect(event, pricing) }}
                        >
                        <option value="">Select one</option>
                        {this.pricingRangeList(pricing)}
                      </select>
                    }
                  </FormGroup>
                </div>
              )
            }
          })
        }
        </div>
      </div>
    );
  }

  render() {
    let {
      serviceTypeStore: {
        serviceType:{
          objects
        },
        serviceTypeDetail,
      },
      preferenceStore:{
        tenant,
        tenant: {
          object
        }
      },
      bookingStore:{
        showUploadAttachmentLoader,
        booking:{
          object:{
            attributes
          },
          isLoading
        }
      },
      questionGroupStore:{
        groups
      },
      serviceTypeCategoryStore:{
        serviceTypeCategories
      }
    } = this.props;

    let service_type_extra = [];
    let pricing_parameters = [];
    let frequency = [];
    let questions = [];

    if(serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      service_type_extra = serviceTypeDetail.object.attributes.service_type_extra
      pricing_parameters = serviceTypeDetail.object.attributes.pricing_parameters
      frequency = serviceTypeDetail.object.attributes.frequency
      questions = serviceTypeDetail.object.attributes.questions
    }

    // Note: in this render `object` is the tenant (booking form settings) and
    // `attributes` is the booking being created.
    const tenantAttributes = object && object.attributes;
    const serviceDetailAttributes = serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes;
    const selectedServiceType = attributes && attributes.service_type_id && _.find(objects, (service) => service.attributes && String(service.attributes.id) === String(attributes.service_type_id));
    const serviceColor = (selectedServiceType && selectedServiceType.attributes.color) || (serviceDetailAttributes && serviceDetailAttributes.color);
    const customerName = attributes ? [attributes.first_name, attributes.last_name].filter((part) => part && String(part).trim() !== '').join(' ') : '';
    // The account's button text (cta_title) is written for customers; staff get the plain action.
    const confirmLabel = 'Confirm booking';
    const pricingLines = [];
    if(attributes && attributes.pricing_parameters) {
      attributes.pricing_parameters.forEach((parameter, index) => {
        pricingLines.push({
          key: `pricing-${index}`,
          label: `${parameter.name} × ${parameter.quantity}`,
          amount: currencyFormattedAmount(parameter.total_amount)
        });
      });
    }
    if(attributes && attributes.pricing_parameter_ranges) {
      attributes.pricing_parameter_ranges.forEach((parameter_range, index) => {
        pricingLines.push({
          key: `range-${index}`,
          label: parameter_range.name,
          amount: currencyFormattedAmount(parameter_range.price)
        });
      });
    }
    const ticketGroups = [{
      key: 'pricing',
      title: (tenantAttributes && tenantAttributes.pricing_title && tenantAttributes.pricing_title !== '') ? tenantAttributes.pricing_title : 'Pricing',
      lines: pricingLines
    }];
    if(service_type_extra && service_type_extra.length > 0 && attributes && attributes.extra_service_types) {
      ticketGroups.push({
        key: 'extras',
        title: 'Add-ons',
        lines: attributes.extra_service_types.map((ext_service, index) => ({
          key: `extra-${index}`,
          label: ext_service.name,
          amount: currencyFormattedAmount(ext_service.price)
        }))
      });
    }
    const showSchedule = (tenantAttributes && tenantAttributes.enable_visit_us === true) ||
      (tenantAttributes && tenantAttributes.enable_often_visit_us === true && frequency && frequency.length > 0);

    let step = 0;
    const nextStep = () => { step += 1; return step; };

    // Skip the Details section when it would be empty.
    const hasDetails = Boolean(
      hasGroupedQuestions(groups, questions)
      || (object && object.attributes && (object.attributes.start_project_expected_period || object.attributes.contact_way || object.attributes.payment_method === true))
    );

    return (
      <div className="bk-page">
        <Helmet>
          <title>{`Booking | FieldNexus`}</title>
        </Helmet>
        {(isLoading || tenant.isLoading) && <div className="spinner-center">
          <Spinner />
        </div>}
        {!isLoading && !tenant.isLoading &&
          <React.Fragment>
            <BookingPageHeader
              title="New booking"
              showStatus={false}
              meta="Fill in the details, then save or confirm"
            >
              <Button
                className={attributes && attributes.status === 'confirmed' ? "bk-btn disable-save-draft-btn" : "bk-btn"}
                onClick={() => this.createBooking('draft')}
                loading={isLoading}
              >
                Save
              </Button>
              <Button
                className="bk-btn"
                intent={Intent.PRIMARY}
                onClick={() => this.createBooking('confirmed')}
                loading={isLoading}
              >
                {confirmLabel}
              </Button>
            </BookingPageHeader>
            <div className="bk-layout">
              <div className="bk-form">
                <BookingSection number={nextStep()} title="Contact" helper="Who the booking is for and how to reach them.">
                  <div className="bk-grid bk-grid--2">
                    <div className="bk-field">
                      <FormGroup
                        label={"First name"}
                        labelFor="text-input"
                        labelInfo={"*"}
                      >
                        <input
                          type='text'
                          className='form-control'
                          placeholder='First name'
                          defaultValue={attributes.first_name}
                          onChange={(event) => {attributes.first_name = event.target.value;}}
                        />
                      </FormGroup>
                    </div>
                    <div className="bk-field">
                      <FormGroup
                        label={"Last name"}
                        labelFor="text-input"
                        labelInfo={"*"}
                      >
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Last name'
                          defaultValue={attributes.last_name}
                          onChange={(event) => {attributes.last_name = event.target.value;}}
                        />
                      </FormGroup>
                    </div>
                    <div className="bk-field">
                      <FormGroup
                        label={"Email"}
                        labelFor="text-input"
                        labelInfo={"*"}
                      >
                        <input
                          type='email'
                          className='form-control'
                          placeholder='mail@domain.com'
                          defaultValue={attributes.email}
                          onChange={(event) => {attributes.email = event.target.value;}}
                        />
                      </FormGroup>
                    </div>
                    <div className="bk-field">
                      <FormGroup
                        label={"Phone"}
                        labelFor="text-input"
                        labelInfo={"*"}
                      >
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ex. 9876543210'
                          defaultValue={attributes.phone}
                          onChange={(event) => {attributes.phone = event.target.value;}}
                        />
                      </FormGroup>
                    </div>
                  </div>
                </BookingSection>

                <BookingSection number={nextStep()} title="Address" helper="Where the work happens.">
                  <div className="bk-grid bk-grid--address">
                    <div className="bk-field">
                      <FormGroup
                        label={"Address"}
                        labelFor="text-input"
                        labelInfo={"*"}
                      >
                        <GeoComplete
                          className='form-control geo-control'
                          placeholder="Search address"
                          initialValue={attributes.address}
                          onSuggestSelect={this.onAddressSelect.bind(this)}
                          onChange={this.onAddressClear.bind(this)}
                        />
                      </FormGroup>
                    </div>
                    <div className="bk-field">
                      <FormGroup
                        label={"Address line 2"}
                        labelFor="text-input"
                      >
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Suite, unit, floor'
                          defaultValue={attributes.suite}
                          onChange={(event) => {attributes.suite = event.target.value;}}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="bk-grid bk-grid--3">
                    <div className="bk-field">
                      <FormGroup
                        label={"City"}
                        labelFor="text-input"
                        labelInfo={"*"}
                      >
                        <input
                          type='text'
                          className='form-control'
                          placeholder='City'
                          value={(attributes.city) || ''}
                          onChange={(event) => {attributes.city = event.target.value;}}
                        />
                      </FormGroup>
                    </div>
                    <div className="bk-field">
                      <FormGroup
                        label={"State or province"}
                        labelFor="text-input"
                        labelInfo={"*"}
                      >
                        <input
                          type='text'
                          className='form-control'
                          placeholder='State or province'
                          value={(attributes.state) || ''}
                          onChange={(event) => {attributes.state = event.target.value;}}
                        />
                      </FormGroup>
                    </div>
                    <div className="bk-field">
                      <FormGroup
                        label={"Zip or postal code"}
                        labelFor="text-input"
                        labelInfo={"*"}
                      >
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ex. 0377'
                          value={(attributes.zip) || ''}
                          onChange={(event) => {attributes.zip = event.target.value;}}
                        />
                      </FormGroup>
                    </div>
                  </div>
                </BookingSection>

                <BookingSection number={nextStep()} title="Service" helper="Pick a category, then the service, its pricing options and add-ons.">
                  {
                    serviceTypeCategories.objects &&
                    <div className="bk-grid bk-grid--2">
                      <div className="bk-field">
                        <FormGroup label={'Service category'} labelFor="text-input" labelInfo={"*"}>
                          <div className="bk-select">
                            <select
                              className='form-control'
                              onChange={this.onServiceTypeCategoryChange.bind(this)}
                            >
                              <option value="">Select category</option>
                              { serviceTypeCategories.objects.map((category) => {
                                  return(
                                    <option value={category.attributes.id} key={category.attributes.id}>{category.attributes.name}</option>
                                  )
                                })
                              }
                            </select>
                            { serviceTypeCategories.objects.length === 0 ?
                                <Spinner className="bk-select__spinner" size={Spinner.SIZE_SMALL} />
                                :
                                ""
                            }
                          </div>
                        </FormGroup>
                      </div>
                    </div>
                  }
                  { object && object.attributes && object.attributes.display_service_type === 'Icon' && attributes && attributes.service_type_category_id != '' ?
                    <div className="bk-subsection">
                      <div className="bk-cards">
                        { objects && objects.map((service,key) => {
                          if(service.attributes.display_on_booking_form) {
                            return (
                              <div
                                key={service.attributes.id}
                                className={this.state.isServiceTypeChecked == service.attributes.id ? 'bk-card bk-card--active': 'bk-card'}
                                style={normalizeHex(service.attributes.color) ? { '--bk-card-accent': normalizeHex(service.attributes.color) } : undefined}
                              >
                                <span className="bk-card__icon">
                                  {service.attributes.logo && <img src={service.attributes.logo} alt="" />}
                                </span>
                                <span className="bk-card__label">{service.attributes.name}</span>
                                <Radio label="" type="radio" name="service_type_id"
                                  className="bk-card__control"
                                  onChange={(event) => {this.onServiceTypeSelect(event,service,key)} }
                                />
                              </div>
                              )
                            }
                          })
                        }
                      </div>
                      {this.renderPricingParameters(pricing_parameters, attributes)}
                    </div>
                    :
                    <div className="bk-subsection">
                      {attributes && attributes.service_type_category_id != '' ?
                      <div>
                        <div className="bk-grid bk-grid--2">
                          <div className="bk-field">
                            <FormGroup label={'Service type'} labelFor="text-input" labelInfo={"*"}>
                              <ServiceTypeSelectWrap color={serviceColor}>
                                <select
                                  className='form-control'
                                  onChange={this.onServiceTypeChange.bind(this)}
                                >
                                  <option value="">Select service</option>
                                  { objects && objects.map((service) => {
                                      if(service.attributes.display_on_booking_form) {
                                        return(
                                          <option value={service.attributes.id} key={service.attributes.id}>{service.attributes.name}</option>
                                        )
                                      }
                                    })
                                  }
                                </select>
                              </ServiceTypeSelectWrap>
                            </FormGroup>
                          </div>
                        </div>
                        {this.renderPricingParameters(pricing_parameters, attributes)}
                      </div>
                      :
                      <p className="bk-hint">Choose a category to see its services.</p>
                      }
                    </div>
                  }

                  {service_type_extra && service_type_extra.length > 0 && <div className="bk-subsection">
                    <h3 className="bk-subsection__title">Add-ons</h3>
                    <div className="bk-cards">
                      {
                        service_type_extra && service_type_extra.length > 0 && service_type_extra.map((extra,key) => {
                          return (
                            <div className={`bk-card ${this.isServiceExtraChecked === key ? 'bk-card--active' :''}`}>
                              <span className="bk-card__icon">
                                {extra.icon_file && extra.icon_file.thumb && extra.icon_file.thumb.url && <img src={extra.icon_file.thumb.url} alt="" />}
                              </span>
                              <span className="bk-card__label">{extra.name}</span>
                              <Checkbox label="" type="checkbox"
                                className="bk-card__control"
                                defaultChecked={this.isServiceExtraChecked}
                                onChange={(event) => {this.onExtraServiceSelect(event,extra,key)} }
                              />
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>}
                </BookingSection>

                {showSchedule &&
                  <BookingSection number={nextStep()} title="Schedule" helper="When the visit happens and how often.">
                    { object && object.attributes && object.attributes.enable_visit_us === true &&
                      <div className="bk-grid bk-grid--2">
                        <div className="bk-field booking_form_date">
                          <FormGroup
                            label={"Date and time"}
                            labelFor="text-input"
                            labelInfo={"*"}
                          >
                            <DateTimeInput
                              placeholder={'Date'}
                              onChange={this.handleStartDateChange.bind(this)}
                            />
                          </FormGroup>
                        </div>
                      </div>
                    }
                    { object && object.attributes && object.attributes.enable_often_visit_us === true &&
                      <div>
                        {frequency && frequency.length > 0 &&
                          <div className="bk-field">
                            <span className="bk-label">How often</span>
                            <div className="bk-chips">
                              {
                                frequency.map((freqncy,frequencyKey) => {
                                  return (
                                    <button
                                      type="button"
                                      key={freqncy.id || frequencyKey}
                                      onClick={(event) => {this.onFrequencySelect(event,freqncy,frequencyKey)} }
                                      className={`bk-chip ${frequencyKey == this.state.isFrequencySelected ? 'bk-chip--active' : ''}`}
                                    >
                                      {freqncy.title}
                                    </button>
                                  )
                                })
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </BookingSection>
                }

                {hasDetails && (
                <BookingSection number={nextStep()} title="Details" helper="Answers to the booking questions and how the customer wants to proceed.">
                  {hasGroupedQuestions(groups, questions) && <div className="bk-questions">
                    {
                      groups.objects.map(function(group) {
                        var isInGroup = questions.map(function(item) { return item.question_group_id; }).indexOf(group.id);
                        if(isInGroup > -1) {
                          return(
                            <div className="bk-question-group" key={group.id}>
                              <h3 className="bk-subsection__title">{group.attributes.question}</h3>
                              {questions && questions.length > 0 && questions.map((question, index) => {
                                  if(group.attributes.id === question.question_group_id){
                                    return(
                                      <div className="bk-question" key={question.id || index}>
                                        <span className="bk-label">{question.field_label}</span>
                                        <div className="bk-question__answer">
                                          {question.field_type === "Checkbox" && <div>
                                            <RadioGroup inline={true} className="bk-radio-group" name="question_radio">
                                              {question.field_value && question.field_value.split(/\r?\n/).map((answer) => {
                                                return(
                                                  <QuestionRadio
                                                    inline= {true}
                                                    bookingStatus={''}
                                                    question={question}
                                                    answer={answer}
                                                  />
                                                )
                                              })}
                                            </RadioGroup>
                                            </div>}
                                            {question.field_type === "Dropdown"  && <div className="bk-question__control">
                                              <QuestionSelect
                                                inline= {true}
                                                question={question}
                                                bookingStatus={''}
                                                selectedAnswer={selectedAnswer}
                                              />
                                            </div>}
                                            {question.field_type === "Textbox"  && <div className="bk-question__control">
                                              <QuestionTextbox
                                                inline= {true}
                                                question={question}
                                                bookingStatus={''}
                                                selectedAnswer={selectedAnswer}
                                              />
                                            </div>}
                                        </div>
                                      </div>
                                    )
                                  }})
                                }
                            </div>
                          )
                        }
                      })
                    }
                  </div>
                  }
                  <div className="bk-grid bk-grid--2">
                    {object && object.attributes && object.attributes.start_project_expected_period && (
                    <div className="bk-field">
                      <FormGroup label={"How soon would you like to start this project?"} labelFor="text-input">
                        <select
                          className='form-control'
                          placeholder={`Select `}
                          onChange={this.onTimePeriodChange.bind(this)}
                          defaultValue={attributes && attributes.start_project_expected_period}
                        >
                          <option value="">Select one</option>
                          {object && object.attributes && object.attributes.start_project_expected_period && object.attributes.start_project_expected_period.split(/\r?\n/).map((period) => {
                            return(
                              <option value={period.split(":")[1]}>{period.split(":")[0]}</option>
                            )})}
                        </select>
                      </FormGroup>
                    </div>
                    )}
                    {object && object.attributes && object.attributes.contact_way && (
                    <div className="bk-field">
                      <FormGroup label={"What is the best way for us to contact you?"} labelFor="text-input">
                        <select
                          className='form-control'
                          placeholder={`Select `}
                          onChange={this.onContactWayChange.bind(this)}
                          defaultValue={attributes && attributes.contact_way}
                        >
                          <option value="">Select one</option>
                          {object && object.attributes && object.attributes.contact_way && object.attributes.contact_way.split(/\r?\n/).map((way) => {
                            return(
                              <option value={way.split(":")[1]}>{way.split(":")[0]}</option>
                            )})}
                        </select>
                      </FormGroup>
                    </div>
                    )}
                  </div>
                  { object && object.attributes && object.attributes.payment_method === true &&
                    <div className="bk-field">
                      <span className="bk-label">Payment method</span>
                      <div className="bk-chips">
                        {
                          items.map((payment,paymentKey) => {
                            return (
                              <button
                                type="button"
                                key={Math.random()}
                                onClick={(event) => {this.onPaymentSelect(event,payment,paymentKey)} }
                                className={`bk-chip ${paymentKey === this.state.isPaymentSelect ? 'bk-chip--active' : ''}`}
                              >
                                {payment.label}
                              </button>
                            )
                          })
                        }
                      </div>
                    </div>
                  }
                </BookingSection>
                )}

                <BookingSection number={nextStep()} title="Attachments" helper="Photos or documents from the customer. Up to 10 MB each.">
                  <BookingAttachments
                    attachments={attributes && attributes.booking_attachments}
                    uploading={showUploadAttachmentLoader}
                    onChange={this.onChangeFile.bind(this)}
                    onRemove={(attachment) => this.removeAttachment(attachment)}
                  />
                </BookingSection>

                <BookingSection number={nextStep()} title="Notes" helper="Anything else the team should know.">
                  <div className="bk-field">
                    <textarea
                      type='text'
                      className='form-control'
                      placeholder='Type here...'
                      defaultValue={attributes.note}
                      onChange={(event) => {attributes.note = event.target.value;}}
                    />
                  </div>
                </BookingSection>
              </div>

              <div className="bk-aside">
                <BookingTicket
                  date={attributes.start_date}
                  customerName={customerName}
                  contact={attributes && [attributes.email, attributes.phone].filter((part) => part).join(', ')}
                  address={attributes && attributes.address ? joinAddress(attributes.address, attributes.suite, attributes.city, attributes.state, attributes.zip) : null}
                  serviceName={serviceDetailAttributes ? serviceDetailAttributes.name : null}
                  serviceDetail={serviceDetailAttributes ? `1 × ${currencyFormattedAmount(parseFloat(serviceDetailAttributes.rate))}` : null}
                  serviceAmount={serviceDetailAttributes ? currencyFormattedAmount(serviceDetailAttributes.rate) : null}
                  serviceColor={serviceColor}
                  groups={ticketGroups}
                  total={currencyFormattedAmount(this.grand_total)}
                >
                  <Button
                    onClick={() => this.createBooking('confirmed')}
                    intent={Intent.PRIMARY}
                    loading={isLoading}
                  >
                    {confirmLabel}
                  </Button>
                  <Button
                    onClick={() => this.createBooking('draft')}
                    className={attributes && attributes.status === 'confirmed' ? "disable-save-draft-btn" : ""}
                    loading={isLoading}
                  >
                    Save
                  </Button>
                </BookingTicket>
              </div>
            </div>
          </React.Fragment>
        }
      </div>
    );
  }

};
export default NewBooking;
